import styled from "styled-components"

export const StyledUserPosts = styled.section`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    gap: 2rem;
`
